import React from "react";
import * as c from "../../../utils/constants/constants";
import './Filter.css';
import {FormControl, Select } from '@mui/material';
import { GetDefaultDate } from "../../../commonFunctions/commonFunctions";
import * as dayjs from "dayjs";


class Filter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            month: "",
            month_arr: c.MONTH_ARR,
            year: "",
            years: [],
            from_date: "",
            to_date: ""
        }
    }

    handleFilterChange(col, value) {
        this.setState({ [col]: value });
        if (col === 'year') {

            let n = parseInt(dayjs().format("M"))
            if (value == this.state.years[this.state.years.length - 1]) {
                var res = [...this.state.month_arr].slice(0,n);
                this.setState({ month_arr: res });
                if (this.state.month > n)
                    this.setState({ month: n });
            } else {
                this.setState({ month_arr: c.MONTH_ARR });
            }
        }
        this.setState({
            [col]: value
        });
    }

    getCurrentMonthAndYear = () => {

        let d =  dayjs().format("M") -1
        let temp_month = d < 10 ? `0${d}`:`${d}`
        let n = parseInt(dayjs().format("M"))
        var res = [...this.state.month_arr].slice(0,n);
        this.setState({ month: temp_month , month_arr: res });
        var max_yr = dayjs().year();
        var min_yr = 2020;
        var years = [];
        for (var i = min_yr; i <= max_yr; i++) {
            years.push(i);
        }
        this.setState({ years: years, year: max_yr });
        var res = n + "," + max_yr;
        return res;
    };

    getDefaultDate = () => {
        let defaultDates = GetDefaultDate({duration: 1, type: "month", format: "YYYY-MM-DD"})
        this.setState({from_date: defaultDates.fromDate, to_date: defaultDates.toDate}) 
    }

    componentDidMount() {
        this.getCurrentMonthAndYear();
        this.getDefaultDate()
    }

    render() {
        return (
            <div className="report-filters">
                    {this.props.selectedUsageTab == "custom_range" ? <>
                    </> :
                        <>
                            <div className="rp-filter">
                                <FormControl
                                    style={{ width: "110px", marginRight: "10px" }}
                                >
                                    <Select
                                        native
                                        value={this.state.year}
                                        variant="standard"
                                        margin="dense"
                                        onChange={e => this.handleFilterChange("year", e.target.value)}
                                        inputProps={{
                                            name: "year",
                                            id: "outlined-age-native-simple",
                                        }}
                                    >
                                        {this.state.years.map((yr, i) => (
                                            <option key={i} value={yr}>
                                                {yr}
                                            </option>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl
                                    style={{ width: "110px", marginRight: "10px" }}
                                >
                                    <Select
                                        native
                                        variant="standard"
                                        value={this.state.month}
                                        margin="dense"
                                        onChange={e => this.handleFilterChange("month", e.target.value)}
                                        inputProps={{
                                            name: "month",
                                            id: "outlined-age-native-simple",
                                        }}
                                    >
                                        {this.state.month_arr.map((month, i) => (
                                            <option key={i} value={("0"+i).slice(-2)}>
                                                {month}
                                            </option>
                                        ))}
                                    </Select>
                                </FormControl>

                        </div>
                        <button
                            className="apply-button"
                            type="submit"
                            onClick={() => this.props.getReportData(this.state)}
                        >
                            <p className="apply-button-text">Apply</p>
                        </button>
                        </>}

                    
            </div>
        )
    }

}
export default Filter;